import { invokeApi } from "src/utils";

export const WalletEstimatedData = async (data) => {
  const requestObj = {
    path: `admin/service/wallet/estimate?network=${data}`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  return invokeApi(requestObj);
};
export const WalletExecuteData = async (data) => {
  const requestObj = {
    path: `admin/service/wallet/execute?network=${data}`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  return invokeApi(requestObj);
};
export const WithdrawBoolean = async (data) => {
  const requestObj = {
    path: `admin/user/withdraw/active/downline/update`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
